import { useEffect, useState } from "react";
import { useApi } from "../lib/api";

const toErrorMessage = (err) => {
  if (!err) return "Unknown error";
  if (typeof err === "string") return err;
  if (err.detail) {
    if (typeof err.detail === "string") return err.detail;
    if (Array.isArray(err.detail) && err.detail[0]?.msg) return err.detail[0].msg;
  }
  if (typeof err.message === "string" && err.message !== "[object Object]") return err.message;
  try {
    return JSON.stringify(err);
  } catch {
    return String(err);
  }
};

export function useUsageEvent(rawUsageEventId) {
  const usageEventId = rawUsageEventId ? rawUsageEventId.trim() : "";
  const api = useApi();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    if (!usageEventId) {
      setEvent(null);
      setLoading(false);
      setError("");
      return () => {
        active = false;
      };
    }

    async function load() {
      try {
        setLoading(true);
        setError("");
        const data = await api(`/usage-events/${encodeURIComponent(usageEventId)}`);
        if (!active) return;
        setEvent(data || null);
      } catch (err) {
        if (!active) return;
        setEvent(null);
        setError(toErrorMessage(err));
      } finally {
        if (active) setLoading(false);
      }
    }

    load();
    return () => {
      active = false;
    };
  }, [api, usageEventId]);

  return { event, loading, error, usageEventId };
}

export default useUsageEvent;
